'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, DropdownMenu } from '@/shared/components/ui';
import { FeatherArchive, FeatherChevronDown, FeatherDownload, FeatherPause, FeatherPlay, FeatherX } from '@subframe/core';
import * as SubframeCore from '@subframe/core';
import type { BulkActionsBarProps } from '../../types/lote.types';
export function BulkActionsBar(t0) {
  const $ = _c(47);
  const {
    selectedCount,
    onPauseSelected,
    onResumeSelected,
    onArchiveSelected,
    onExportSelected,
    onClearSelection,
    isLoading
  } = t0;
  if (selectedCount === 0) {
    return null;
  }
  const t1 = selectedCount === 1 ? "selecionada" : "selecionadas";
  let t2;
  if ($[0] !== selectedCount || $[1] !== t1) {
    t2 = <span className="text-body-bold font-body-bold text-default-font">{selectedCount} {t1}</span>;
    $[0] = selectedCount;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherX />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isLoading || $[5] !== onClearSelection) {
    t4 = <Button variant="neutral-tertiary" size="small" icon={t3} onClick={onClearSelection} disabled={isLoading} />;
    $[4] = isLoading;
    $[5] = onClearSelection;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className="flex items-center gap-2 border-r border-neutral-200 pr-4">{t2}{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherPause />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isLoading || $[12] !== onPauseSelected) {
    t7 = <Button variant="neutral-secondary" size="small" icon={t6} onClick={onPauseSelected} disabled={isLoading}>Pausar</Button>;
    $[11] = isLoading;
    $[12] = onPauseSelected;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatherPlay />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isLoading || $[16] !== onResumeSelected) {
    t9 = <Button variant="neutral-secondary" size="small" icon={t8} onClick={onResumeSelected} disabled={isLoading}>Retomar</Button>;
    $[15] = isLoading;
    $[16] = onResumeSelected;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FeatherArchive />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== isLoading || $[20] !== onArchiveSelected) {
    t11 = <Button variant="neutral-secondary" size="small" icon={t10} onClick={onArchiveSelected} disabled={isLoading}>Arquivar</Button>;
    $[19] = isLoading;
    $[20] = onArchiveSelected;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="h-6 w-px bg-neutral-200" />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FeatherDownload />;
    t14 = <FeatherChevronDown />;
    $[23] = t13;
    $[24] = t14;
  } else {
    t13 = $[23];
    t14 = $[24];
  }
  let t15;
  if ($[25] !== isLoading) {
    t15 = <SubframeCore.DropdownMenu.Trigger asChild={true}><Button variant="brand-secondary" size="small" icon={t13} iconRight={t14} disabled={isLoading}>Exportar</Button></SubframeCore.DropdownMenu.Trigger>;
    $[25] = isLoading;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FeatherDownload />;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== onExportSelected) {
    t17 = <DropdownMenu.DropdownItem icon={t16} onClick={() => onExportSelected("csv")}>Exportar como CSV</DropdownMenu.DropdownItem>;
    $[28] = onExportSelected;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <FeatherDownload />;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== onExportSelected) {
    t19 = <DropdownMenu.DropdownItem icon={t18} onClick={() => onExportSelected("xlsx")}>Exportar como Excel (.xlsx)</DropdownMenu.DropdownItem>;
    $[31] = onExportSelected;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t17 || $[34] !== t19) {
    t20 = <SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content align="end" className="animate-fade-in w-64"><DropdownMenu>{t17}{t19}</DropdownMenu></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal>;
    $[33] = t17;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t15 || $[37] !== t20) {
    t21 = <SubframeCore.DropdownMenu.Root>{t15}{t20}</SubframeCore.DropdownMenu.Root>;
    $[36] = t15;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t11 || $[40] !== t21 || $[41] !== t7 || $[42] !== t9) {
    t22 = <div className="flex items-center gap-2">{t7}{t9}{t11}{t12}{t21}</div>;
    $[39] = t11;
    $[40] = t21;
    $[41] = t7;
    $[42] = t9;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t22 || $[45] !== t5) {
    t23 = <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 transform"><div className="flex items-center gap-3 rounded-2xl border border-neutral-200 bg-white px-6 py-4 shadow-2xl">{t5}{t22}</div></div>;
    $[44] = t22;
    $[45] = t5;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  return t23;
}